import type { ExtendedSelectKey } from "@/config/extendedSelectRowMap";

export const EXTENDED_SELECT_STALE_TIME_MS = 5 * 60_000;
export const EXTENDED_SELECT_GC_TIME_MS = 30 * 60_000;

export const extendedSelectKeys = {
  all: ["extended-select"] as const,
  one: (key: ExtendedSelectKey) => ["extended-select", key] as const,
};
